import { useSyncExternalStore } from 'react'

const useIsScrolled = () => useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot)

const subscribe = callback => {
  window.addEventListener('scroll', callback)
  return () => window.removeEventListener('scroll', callback)
}

const getSnapshot = () => window.pageYOffset >= 54

const getServerSnapshot = () => false

export default useIsScrolled
